var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_542_21998)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 17,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM19.0312 15.7269V9.58734C19.0312 8.31741 17.9985 7.28498 16.7286 7.28498H15.4205C15.0978 7.28498 14.8345 7.02173 14.8345 6.699V6.47217C14.8345 5.67839 14.1893 5.03288 13.3955 5.03288H10.6046C9.81084 5.03288 9.16561 5.67844 9.16561 6.47217V6.699C9.16561 7.02178 8.90241 7.28498 8.57963 7.28498H7.27153C6.00173 7.28498 4.96875 8.31745 4.96875 9.58734V15.7269C4.96875 16.9968 6.00169 18.0295 7.27153 18.0295H16.7287C17.9985 18.0296 19.0312 16.9968 19.0312 15.7269ZM12.0001 8.39728C9.81281 8.39728 8.03325 10.1768 8.03325 12.3641C8.03325 14.5515 9.81281 16.331 12.0001 16.331C14.1874 16.331 15.9669 14.5515 15.9669 12.3641C15.9669 10.1768 14.1874 8.39728 12.0001 8.39728ZM12.0001 15.3934C13.6706 15.3934 15.0294 14.0347 15.0294 12.3641C15.0294 10.6936 13.6706 9.33483 12.0001 9.33483C10.3296 9.33483 8.9708 10.6936 8.9708 12.3641C8.97075 14.0347 10.3296 15.3934 12.0001 15.3934Z",
    fill: "#5A5AF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_542_21998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCamera);
export default __webpack_public_path__ + "static/media/blueCamera.10f86a1b9701ebd1fc6d317ca9437f3a.svg";
export { ForwardRef as ReactComponent };